// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Mis groups'" tab="true"></sub-header>
  <table class="table">
    <thead>
    <tr>
      <th class="number no-column">No</th>
      <th class="name">Name</th>
      <th class="code">Code</th>
      <th class="fullcode">FullCode</th>
    </tr>
    </thead>
    <tbody>
    <tr ng-repeat="misGroup in \$ctrl.misGroupView">
      <td>{{\$index + 1}}</td>
      <td>
         <span ng-style="{'padding-left': 'calc(1rem * ({{misGroup.depth}} - 1))'}"></span>
        {{misGroup.name}}
      </td>
      <td>
        {{misGroup.code}}
      </td>
      <td class="fullcode">
        {{misGroup.fullCode}}
      </td>
    </tr>
    </tbody>
  </table>

  <div class="buttons">
    <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Back</button>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/mis-group-list/mis-group-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;